/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'close-strong': {
    width: 15,
    height: 16,
    viewBox: '0 0 15 16',
    data: '<defs><linearGradient id="svgicon_close-strong_a" x1="100%" x2="0%" y1="46.485%" y2="46.485%"><stop offset="0%" stop-color="#FC584D"/><stop offset="100%" stop-color="#E5092B"/></linearGradient></defs><g _fill="none" fill-rule="evenodd" _stroke="url(#svgicon_close-strong_a)" stroke-linecap="round" stroke-linejoin="round" transform="translate(1 1)"><path pid="0" stroke-width="2" d="M.167.507l12.574 12.181"/><path pid="1" stroke-width="2.364" d="M.364 12.884L12.545.31"/></g>'
  }
})
